const MCOM_SEQUENCE = ['sale', 'category', 'brand', 'category', 'brand'];
const BCOM_SEQUENCE = ['category', 'brand', 'sale', 'category', 'brand', 'category'];

const PROS_ZOR_TABS_SEQUENCE = {
  mcom: {
    notSignedIn: MCOM_SEQUENCE,
    signedIn: MCOM_SEQUENCE,
  },
  bcom: {
    notSignedIn: BCOM_SEQUENCE,
    signedIn: BCOM_SEQUENCE.slice(0, -1),
  },
};

const TAB_NAME_TRANSFORMATIONS = {
  original: 'original_card_name',
  lowercased: 'lowercased_card_name',
  capitalized: 'capitalized_card_name',
};

const TAB_TITLE_VARIATIONS = {
  mcom: {
    sale: {
      notSignedIn: ['Best sellers'],
      signedIn: ['On sale now'],
    },
    category: {
      notSignedIn: [`Trending ${TAB_NAME_TRANSFORMATIONS.lowercased}`, `${TAB_NAME_TRANSFORMATIONS.capitalized} we picked`],
      signedIn: [`${TAB_NAME_TRANSFORMATIONS.capitalized} you might like`, `${TAB_NAME_TRANSFORMATIONS.capitalized} we picked`],
    },
    brand: {
      notSignedIn: [`Shop ${TAB_NAME_TRANSFORMATIONS.original}`, `More ${TAB_NAME_TRANSFORMATIONS.original}`],
      signedIn: [`Shop ${TAB_NAME_TRANSFORMATIONS.original}`, `From ${TAB_NAME_TRANSFORMATIONS.original}`],
    },
  },
  bcom: {
    sale: {
      notSignedIn: ['Best sellers, on sale'],
      signedIn: ['Sale picks for you'],
    },
    category: {
      notSignedIn: [
        `Trending ${TAB_NAME_TRANSFORMATIONS.lowercased}`,
        `Popular ${TAB_NAME_TRANSFORMATIONS.lowercased}`,
        `In demand ${TAB_NAME_TRANSFORMATIONS.lowercased}`,
      ],
      signedIn: [`${TAB_NAME_TRANSFORMATIONS.capitalized} you'll love`],
    },
    brand: {
      notSignedIn: [`Shop ${TAB_NAME_TRANSFORMATIONS.original}`],
      signedIn: [`Shop ${TAB_NAME_TRANSFORMATIONS.original}`],
    },
  },
};

const MAX_TABS_COUNT = {
  mcom: {
    notSignedIn: 6,
    signedIn: 6,
  },
  bcom: {
    notSignedIn: 7,
    signedIn: 6,
  },
};

const TAB_CATEGORY_NAME_MAP = {
  Women: "Women's items",
  Men: "Men's items",
  Kids: 'Kids items',
  Baby: 'Baby items',
};

const RVI_TAB_TITLE = 'Continue shopping';

export { PROS_ZOR_TABS_SEQUENCE, MAX_TABS_COUNT, TAB_TITLE_VARIATIONS, TAB_NAME_TRANSFORMATIONS, TAB_CATEGORY_NAME_MAP, RVI_TAB_TITLE };
